import { useLocation } from 'react-router-dom';
import { Search } from 'lucide-react';

// Map routes to page titles and breadcrumbs
const routeConfig: Record<string, { title: string; breadcrumb: string[] }> = {
  '/': { title: 'Dashboard', breadcrumb: ['Home'] },
  '/people': { title: 'People', breadcrumb: ['People'] },
  '/organisations': { title: 'Organisations', breadcrumb: ['Organisations'] },
  '/volunteers': { title: 'Volunteers', breadcrumb: ['Volunteers'] },
  '/assets': { title: 'Assets', breadcrumb: ['Assets'] },
  '/reports': { title: 'Reports', breadcrumb: ['Reports'] },
  '/finance': { title: 'Finance', breadcrumb: ['Finance'] },
  '/settings': { title: 'Settings', breadcrumb: ['Settings'] },
  '/team-management': { title: 'Team Management', breadcrumb: ['Team Management'] },
  '/system-settings': { title: 'System Settings', breadcrumb: ['System Settings'] },
};

export default function Header() {
  const location = useLocation();
  const config = routeConfig[location.pathname] || { title: 'Page', breadcrumb: [] };

  return (
    <header className="sticky top-0 z-20 bg-white border-b border-gray-200">
      <div className="flex items-center justify-between px-6 py-4">
        {/* Left side: Title and breadcrumb */}
        <div className="min-w-0 flex-1">
          <nav className="flex items-center text-sm text-gray-500 mb-1" aria-label="Breadcrumb">
            {config.breadcrumb.map((item, index) => (
              <span key={item} className="flex items-center">
                {index > 0 && (
                  <span className="mx-2 text-gray-300">/</span>
                )}
                <span className={index === config.breadcrumb.length - 1 ? 'text-gray-700' : ''}>
                  {item}
                </span>
              </span>
            ))}
          </nav>
          <h1 className="text-2xl font-semibold text-gray-900 truncate">
            {config.title}
          </h1>
        </div>

        {/* Right side: Search */}
        <div className="flex items-center gap-3 ml-4">
          <div className="hidden md:flex items-center">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
              <input
                type="search"
                placeholder="Search..."
                className="w-64 pl-9 pr-4 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-sca-purple-500 focus:border-transparent"
              />
            </div>
          </div>

          {/* Mobile search button */}
          <button
            className="md:hidden p-2 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100"
            aria-label="Search"
          >
            <Search className="h-5 w-5" />
          </button>
        </div>
      </div>
    </header>
  );
}
